import { createApp } from 'vue';
import { createPinia } from 'pinia';

// locize
import i18n from './locize/i18n';

// bootstrap
import './assets/scss/custom.scss';
import 'bootstrap';

import '@ag-grid-community/styles/ag-grid.css';
import '@ag-grid-community/styles/ag-theme-quartz.css';
import 'flag-icons/css/flag-icons.min.css';
import { LicenseManager } from 'ag-grid-enterprise';

// font awsome
import InitIcons from './fontawesome/fontawsome';

import WeatherIcons from './assets/img/weather/weathericons';

import App from './App.vue';
import router from './router';

import i18nmarkedPlugin from './locize/i18nmarked';
import { GetAppsetting } from '@/composeables';
import { isLocalHost, isNextDev } from './utilities/utils';

try {
    LicenseManager.setLicenseKey(GetAppsetting('aggrid_licence_key'));
} catch (e) {
    console.error(e);
} finally {
    const app = i18n(createApp(App));
    InitIcons(app);

    // Register weather icons globally
    for (const name in WeatherIcons) {
        app.component(name, WeatherIcons[name]);
    }

    app.use(i18nmarkedPlugin);
    app.use(createPinia());
    app.use(router);

    app.mount('#app');
}

if (isLocalHost()) {
    console.log('Development mode detected: switching favicon');
    const favicon = document.getElementById('favicon');
    if (favicon) favicon.setAttribute('href', '/favicon-local.ico');
}

if (isNextDev()) {
    const favicon = document.getElementById('favicon');
    if (favicon) favicon.setAttribute('href', '/favicon-dev.ico');
}
